import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPencil, faUserPlus, faSpinner, faEye, faLock, faChevronRight, faChevronLeft, faClose } from '@fortawesome/free-solid-svg-icons';

const iconMap = {
    edit: faPencil,
    delete: faTrash,
    close: faClose,
    invite: faUserPlus,
    spinner: faSpinner,
    eye: faEye,
    lock: faLock,
    chevronRight: faChevronRight,
    chevronLeft: faChevronLeft,
};

export default function Icon({ icon, className = "" }) {
    return <FontAwesomeIcon icon={iconMap[icon] || null} className={className} />;
}
